import { isEmpty } from '@jjj/components';
import actions from './actions';
import { createReducer } from '../../../helpers/reducer';
import { keyBy } from '../../../helpers/core';
import { t } from '../../../i18n';

const initState = {
  editPaystubForm: null,
  formData: null,
  baseError: null,
  loading: false,
  paystubUpdated: false,
  buttonToShowLoader: null,
};

function validate(attr, value) {
  let error = '';

  if (attr === 'import_start_date') {
    if (isEmpty(value)) {
      error = t('dash.validation.required_error', { fieldName: t('dash.admin.payroll.import_start_time') });
    }
  }

  if (attr === 'import_finish_date') {
    if (isEmpty(value)) {
      error = t('dash.validation.required_error', { fieldName: t('dash.admin.payroll.import_finish_time') });
    }
  }

  if (attr === 'attachment') {
    if (isEmpty(value)) {
      error = t('dash.validation.file_is_missed');
    }
  }

  if (attr === 'file') {
    if (isEmpty(value)) {
      error = t('dash.validation.file_is_missed');
    }
  }

  return error;
}

function onLoad(state) {
  const editPaystubForm = {
    file: {
      name: 'file',
      value: null,
      error: validate('file', ''),
      touched: false,
    },
    paystubInitialFileList: {
      name: 'paystubInitialFileList',
      value: [],
      error: '',
      touched: false,
    },
  };

  return {
    ...state,
    editPaystubForm,
  };
}

function onClearStore() {
  return { ...initState };
}

function onSaveSuccess(state) {
  return {
    ...state,
    paystubUpdated: true,
  };
}

function onSaveError(state, { payload }) {
  const { data } = payload;

  const baseError = data.base ? data.base[0] : null;

  return {
    ...state,
    baseError,
  };
}

function onUploadPaystub(state) {
  return {
    ...state,
    buttonToShowLoader: 'upload-paystub',
  };
}

function onChangeProperty(state, { payload }) {
  const { attr, value } = payload;
  const { editPaystubForm } = state;

  if (editPaystubForm && editPaystubForm[attr]) {
    editPaystubForm[attr] = {
      value,
      error: validate(attr, value),
      name: attr,
      touched: true,
    };

    return {
      ...state,
      editPaystubForm,
    };
  }

  return {
    ...state,
  };
}

function onTouch(state, { payload }) {
  const propsArray = Object.entries(payload.editForm);
  const editForm = keyBy(
    propsArray,
    entry => entry[0],
    entry => {
      const [, value] = entry;

      return {
        ...value,
        touched: true,
      };
    },
  );

  return {
    ...state,
    editPaystubForm: editForm,
  };
}

export { validate };
export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.CLEAR_STORE]: onClearStore,
  [actions.UPLOAD_PAYSTUB]: onUploadPaystub,
  [actions.CHANGE_PROPERTY]: onChangeProperty,
  [actions.SAVE_SUCCESS]: onSaveSuccess,
  [actions.SAVE_ERROR]: onSaveError,
  [actions.TOUCH]: onTouch,
});
